export const AiMlPageData = {
  bannerContent: {
    shortHeading: "Artificial intelligence & ML Development Services",
    mainHeading: "At the Vanguard of <span>AI & ML</span> Innovation, Trusted by Industry Giants",
    description: "Revolutionize your business with our AI & ML development services. As a top AI & ML development company, we lead with innovation to help you thrive in today’s AI era.",
  },
  whyUsContent: {
    shortHeading: "150+ Successful Projects in Web & AI Development",
    heading: " the Next Era of AI Innovation",
    greenHeading: "Pioneering",
    image: "/images/why-us-section/aiml-why-us-image.avif",
    content: "Businesses & organizations count on us for advanced AI & ML services that work. Utilizing proven approaches, AI Advanced technologies, & data-driven strategies, we convert complex challenges into exciting opportunities for growth.",
    stats: [
      {
        title: "AI/Ml Integrations",
        number: "200+"
      },
      {
        title: "Efficiency Gains",
        number: "40%"
      },
      {
        title: "Faster Execution",
        number: "10x"
      },
      // {
      //   title: "Industries served with AI/Ml",
      //   number: "6+"
      // },
      // {
      //   title: "Since AI Services",
      //   number: "2017"
      // },
      // {
      //   title: "AI/ML Engineers",
      //   number: "150+"
      // },
    ],
    cta: {
      text: "Partner With us Today",
      link: "/contact-us",
    }
  },
  testimonialData: {
    shortHeading: "See Why Customers Love Bitsclan",
    mainHeading: "Voices of <span>Global</span> Enterprises on Our AI & ML Excellence",
    description: "Discover why businesses trust Bitsclan for cutting-edge AI & ML solutions. Read real feedback from clients who achieved success with our services.",
    testimonials: [
      {
        name: "Michael Turner",
        enterprise: "Enterprise Automation",
        country: "Austin, US",
        countryFlagImage: "/images/testimonials/flags/usa-flag.png",
        designation: "CTO at BrightPath Logistics",
        profileImage: "/images/testimonials/michael.avif",
        logoImage: "/images/logo-2.png",
        text: "Bitsclan built a chatbot that now handles most of our customer queries. Response times are down to seconds, & our support team is free to focus on complex issues. It’s been a huge boost to efficiency & customer satisfaction.",
        serviceTags: [
          { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
          { title: "AI Automation", link: "/ai-automation-agency" },
          { title: "Generative AI", link: "/generative-ai-development-services" }
        ]
      },
      {
        name: "Sophie Keller",
        enterprise: "Healthcare AI",
        country: "Florida, US",
        countryFlagImage: "/images/testimonials/flags/usa-flag.png",
        designation: "Head of Digital Transformation at Meditech Solutions",
        profileImage: "/images/testimonials/sophie.avif",
        logoImage: "/images/logo-2.png",
        text: "With Bitsclan’s agentic AI, we’ve automated routine admin tasks like scheduling & reporting. Our staff now spends more time with patients, & errors have dropped noticeably. The solution fit right into our workflow.",
        serviceTags: [
          { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
          { title: "AI Automation", link: "/ai-automation-agency" },
          { title: "Generative AI", link: "/generative-ai-development-services" }
        ]
      },
      {
        name: "Sarah Coleman",
        enterprise: "Construction & Industrial Equipment",
        country: "Illinois, US",
        countryFlagImage: "/images/testimonials/flags/usa-flag.png",
        designation: "Training & Product Specialist at American Moisture Test",
        profileImage: "/images/testimonials/sarah.avif",
        logoImage: "/images/testimonials/logo-amt.png",
        text: "Partnering with Bitsclan allowed us to digitize our testing workflow. From product tracking to client reporting, everything is now managed in one unified system. The team’s industrial understanding and precision execution exceeded our expectations.",
        serviceTags: [
          { title: "Custom Web Development", link: "/custom-software-development-services" },
          { title: "Equipment Management System", link: "#" },
          { title: "ERP Integration", link: "#" }
        ]
      }
    ]
  },
  caseStudyContent: {
    shortHeading: "Real-World Success with AI & ML",
    heading: "Transformative Outcomes Powered by Our <span>AI & ML</span> Innovation.",
    description: "Discover Bitsclan’s AI & ML development success stories. Learn how our innovative AI solutions boost efficiency, solve challenges, & drive business growth across industries with trusted, scalable AI/ML technology."
  },
  aimlServices: {
    heading: "Transforming Ideas into Scalable Realities Through World-Class <span>AI Solutions.</span>",
    shortHeading: "AI ML Development Services & Solutions",
    description: "As a trusted AI & ML development service company, we help businesses unlock growth with intelligent, future-ready AI solutions. Our AI & machine learning specialists deliver tailored strategies by integrating agentic AI, custom LLMs, & generative AI to streamline operations & enhance customer experiences.",
    cardsData: [
      {
        title: "Chatbots & Virtual Agents",
        description:
          "Artificial intelligence development services expand customer service capabilities. Our Intelligent virtual agents can process a high volume of inquiries simultaneously & provide immediate feedback, handling basic issue resolution.",
        link: "/ai-chatbot-development-services",
      },
      {
        title: "Agentic AI services",
        description:
          "Our agentic AI services are custom-built to automate decisions & adapt well to real-world challenges. Our experts design solutions using advanced algorithms & natural language processing, tailored to your business needs.",
        link: "/ai-agent-development-services"
      },
      {
        title: "Generative AI Development Services",
        description:
          "Revamp your existing software products with our end-to-end generative AI & ML development services. Our AI devs design intelligent features that elevate performance & user experience.",
        link: "/generative-ai-development-services"
      },
      {
        title: "LLMs Development Services",
        description:
          "Large Language Models (LLMs) are transforming how businesses automate tasks & deliver personalized experiences. Bitsclan’s LLM development services create intelligent AI systems that understand & process human language at scale.",
      },
      {
        title: "AI-driven Automation",
        description:
          "We enhance multiple areas of your business with our AI automation services by efficiently managing both routine & complex tasks. It will help you to process faster, reduce errors, & free up valuable time for strategic & creative initiatives.",
        link: "/ai-automation-agency"
      },
      {
        title: "Natural Language Processing (NLP)",
        description:
          "We also offer NLP development services to create AI solutions. Our ai ml software engineers utilize NLP techniques to help businesses in assessment of consumer feedback & queries effectively.",
      },
      {
        title: "Machine Learning Development",
        description:
          "We use our machine learning expertise to design smarter AI solutions tailored to your business. Through our AI & machine learning development services, we transform unstructured data into meaningful & actionable insights through automations.",
      },
      {
        title: "AI & ML Consulting",
        description:
          "Our AI & ML consulting services help businesses to make smarter decisions with high data-driven intelligence. From strategic planning to practical deployment, we deliver customized AI enabled solutions that enhance automation, accuracy, & operational agility.",
      },
    ]
  },
  trendingInsights: {
    heading: "Insights & Perspectives on Emerging Technologies",
    description:
      "Learn the latest in AI & Machine Learning services. Get practical insights, expert opinions, & strategies to stay ahead in the tech landscape.",
  },
  roadmapContent: {
    shortHeading: "Proven AI ML Development Roadmap",
    heading: "From Vision to <span>Execution</span> in 4 Weeks",
    description:
      "Kickstart your AI & ML projects faster with Bitsclan. From strategy to execution, we help you build powerful, scalable solutions that deliver results in just 3–4 weeks.",
    processData: [
      {
        title: "Plan Your AI Strategy & Team Setup",
        description: "Share your goals, timeline, & budget. We’ll design a detailed AI/ML strategy & define the perfect team structure to match your success metrics.",
        icon: "/images/roadmap-icons/ai-strategy.svg"
      },
      {
        title: "Assemble Skilled AI & ML Experts Quickly",
        description: "With the plan locked, we onboard top engineers & developers. Your dedicated team is ready to start delivering results within 3–4 weeks.",
        icon: "/images/roadmap-icons/assemble-skilled.svg"
      },
      {
        title: "Development, Testing & Implementation",
        description: "Our AI ML experts design, build, & rigorously test your solutions to ensure smooth functionality. Once validated, we implement them effectively, setting clear goals for reliable, future-ready results.",
        icon: "/images/roadmap-icons/development-strategy.svg"
      },
    ],
    cta: {
      text: "Book a Call",
      link: "https://calendly.com/bitsclan-it/30min?"
    }
  },
  faqSection: {
    heading: "AI & Machine Learning Development: FAQs",
    questionAnswers: [
      {
        id: "collapseOne",
        question: "Can I hire an AI ML developer as a freelancer to work hourly or project based?",
        answer: "Yes! At Bitsclan, we offer various hiring models including hourly, weekly & monthly mode of hire. So, you can hire AI ML developers on an hourly basis or on a project/task basis, & can change the hire model type later if you wish!"
      },
      {
        id: "collapseTwo",
        question: "How much does an AI ml developer cost?",
        answer: "The cost of hiring an AI ml developer varies depending on factors such as expertise, project complexity, & reputation of an Artificial Intelligence app development company. For a precise estimate, you can contact us, & we’ll be pleased to discuss your specific project requirements."
      },
      {
        id: "collapseThree",
        question: "Can non-technical teams use AI solutions?",
        answer: "Yes. Many AI platforms now offer no-code or low-code interfaces, enabling non-technical users to deploy models, analyze data, & automate processes without coding expertise."
      },
      {
        id: "collapseFour",
        question: "What industries benefit most from AI & ML?",
        answer: "AI & ML are transforming industries like healthcare, finance, retail, manufacturing, logistics, & SaaS, helping them improve efficiency, accuracy, & customer engagement."
      },
      {
        id: "collapseFive",
        question: "How can AI improve customer service?",
        answer: "AI-powered chatbots, voice assistants, & automated support systems provide 24/7 customer service, resolve queries faster, & personalize interactions for higher satisfaction."
      },
      {
        id: "collapseSix",
        question: "What are the future trends in AI & ML?",
        answer: "The future of business is AI-driven, & companies leveraging it will gain a major competitive advantage. Trends like generative AI, AI-powered automation, predictive analytics, personalized AI solutions, computer vision, & NLP are transforming industries. By adopting AI & ML services now, your business can stay ahead of the curve, streamline operations, & unlock new growth opportunities."
      }
    ],
  },
  companyCta: {
    heading: " See why global brands choose us for <br/>AI & ML Services.",
    // subHeading: "See how our expert developers can help.",
    buttonText: "Let's Discuss Your AI ML Project",
  },

  engagementModels: {
    shortHeading: "Flexible Engagement Models",
    heading: "Flexible Access to World-Class AI & ML Expertise",
    subheading: "From strategy to delivery, we customize AI & ML services to match your workflow & accelerate results.",
    models: [
      {
        icon: "/images/engagement-model-gifs/hourly-icon.svg",
        index: 1,
        iconWidth: 40,
        title: "Dedicated Teams (Nearshore & Offshore)",
        bestForText: ["Startups", "Growing Companies", "Enterprises",],
        description: "Get a full-time AI/ML team of data scientists, ML engineers, & MLOps experts fully aligned with your goals. Our teams act as an extension of your organization, ensuring continuous collaboration, rapid iteration, & measurable outcomes."
      },
      {
        icon: "/images/engagement-model-gifs/price-icon.svg",
        index: 2,
        iconWidth: 35,
        title: "Fixed Price Projects",
        bestForText: ["SMBs", "Startups", "Product Teams",],
        description: "Ideal for AI/ML initiatives with a clearly defined scope, such as proof of concepts or MVPs. We deliver within a fixed budget & timeline, giving you predictable results with zero surprises - perfect for validating ideas before scaling."
      },
      {
        icon: "/images/engagement-model-gifs/retainer-icon.svg",
        index: 3,
        iconWidth: 35,
        title: "Build Operate Transfer (BOT)",
        bestForText: ["Large Enterprises", "Corporations", "Global Teams",],
        description: "For businesses planning long-term AI/ML capability building, we set up & operate your dedicated AI team, infrastructure, & processes. Once the operation is mature, we transfer it to you, giving you full ownership with minimal risk."
      }
    ],
    cta: {
      text: "Talent on Your Terms",
      button: "Talk to An Expert",
      link: "/contact-us",
    },
  },
  industries: {
    shortHeading: "",
    heading: "",
    description: "",
    serviceTags: [
      { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
      { title: "AI Automation", link: "/ai-automation-agency" },
      { title: "Generative AI", link: "/generative-ai-development-services" }
    ],
    tabData: [
      {
        id: 1,
        slug: "healthcare",
        title: "Healthcare",
        description: "We provide customized AI services & healthcare AI consulting, including EHR systems & patient management platforms, to improve care delivery, ensure compliance, & boost operational efficiency in the healthcare industry.",
        image: "healthcare.avif",
        icon: "/images/heart.png",
      },
      // {
      //   id: 2,
      //   slug: "fintech",
      //   title: "Fintech",
      //   description: "Fintech thrives on innovation, & we’re here to drive it forward. Our AI in fintech web apps simplify complex financial processes, from secure payment systems to intelligent financial planning tools.",
      //   image: "fintech.png",
      //   icon: "/images/Fintech.png",
      // },
      {
        id: 3,
        slug: "retail-ecommerce",
        title: "E-commerce & Retail",
        description: "We help retailers leverage generative AI in e-commerce to enhance inventory management, deliver personalized shopping experiences, & optimize omnichannel platforms, driving higher sales & stronger customer loyalty.",
        icon: "/images/ecommerce-icon.png",
        image: "ecommerce.avif",
      },
      {
        id: 4,
        slug: "real-estate",
        title: "Real Estate",
        description: "We provide real estate professionals with property management systems, CRM platforms, & secure transaction solutions, & our AI ML engineers design intelligent tools to streamline operations & enhance client interactions.",
        icon: "/images/RealEstate.png",
        image: "realestate.avif",
      },
      {
        id: 5,
        slug: "automotive-logistics",
        title: "Automotive & Logistics",
        description: "Our AI automation & workflow solutions empower the automotive & logistics industries by streamlining vehicle tracking, fleet management, supply chains, & inventory workflows. From managing operations & customer communications to real-time updates & seamless coordination, we help businesses boost efficiency, reduce complexity, & deliver a smoother experience for everyone.",
        icon: "/images/automotive-icon.png",
        image: "automotive.avif",
      },
      {
        id: 6,
        slug: "education",
        title: "Education",
        description: "Education should be engaging & accessible, & our web apps make it possible. From e-learning platforms to classroom management tools, we design AI-powered education solutions that support students, educators, & institutions, bringing everyone closer to success.",
        icon: "/images/education-icon.png",
        image: "education.avif",
      },
      // {
      //   id: 7,
      //   slug: "insurance",
      //   title: "Insurance",
      //   description: "We help insurance companies run better by offering AI-enabled automation & workflow solutions. We are a trusted AI automation agency, providing secure, scalable systems that can adapt to the evolving needs of the insurance industry.",
      //   icon: "/images/Insurance.png",
      //   image: "insurance.png",
      // },
      {
        id: 9,
        slug: "gaming-entertainment",
        title: "Entertainment & Gaming",
        description: "Our AI automation services for the entertainment & gaming industries optimize content management, audience analytics, & intellectual property protection, while also enhancing in-game automation, player interactions, & operations. We help businesses increase efficiency in content distribution, create better audience engagement, expand player support, & deliver smoother, more immersive experiences.",
        icon: "/images/industry-gaming-icon.png",
        image: "entertainmentMain.avif",
      },
      // {
      //   id: 11,
      //   slug: "social-networking",
      //   title: "Social Networking",
      //   description: "We deliver AI automation & workflow solutions for social media platforms, increasing engagement, automating analytics, & ensuring secure data management. Our AI services enhance interactions while keeping processes efficient & secure.",
      //   icon: "/images/SocialNetworking.png",
      //   image: "Social.png",
      // },
      // {
      //   id: 12,
      //   slug: "telecom",
      //   title: "Telecom",
      //   description: "Our AI automation services for the telecom sector streamline processes like billing management, network optimization, & customer relationship operations. By automating these workflows, we help telecom companies improve efficiency, reduce errors, & deliver consistently better experiences to their customers.",
      //   icon: "/images/Telecom.png",
      //   image: "telecom.png",
      // },
      // {
      //   id: 13,
      //   slug: "energy",
      //   title: "Energy",
      //   description: "We provide advanced AI automation & workflow solutions for the energy sector. From smart grid management & resource optimization to secure trading platforms, our automated workflows help energy companies operate smarter & more efficiently.",
      //   icon: "/images/Energy.png",
      //   image: "energy.png",
      // },
      // {
      //   id: 14,
      //   slug: "agriculture",
      //   title: "Agriculture",
      //   description: "Our smart automation solutions in the agricultural industry, help farmers optimize irrigation, monitor crops efficiently, & manage resources effectively. It can boost yields & support sustainable farming practices.",
      //   icon: "/images/industries-icons/Agriculture.svg",
      //   image: "Agriculture.avif",
      // }
    ]
  },
};
